import { Action } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, takeEvery } from 'redux-saga/effects';
import { HomeCloseWelcomeScreen } from '../../app/actions/AppActionTypes';
import { ServiceLocator } from '../../app/ServiceLocator';
import { SetShowWelcomeScreenRequest } from '../../ts/ServerApi/requests/SetShowWelcomeScreenRequest';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { ServerService } from '../../ts/services/ServerService';

export function* homeCloseWelcomeScreen(action: Action) {
  try {
    yield call(sendCloseWelcomeScreenRequest);
  }
  catch(e) {
    // TODO: Fire off a failure log, we don't want to display a toast to the user in this case.
    yield call(logHomeFailure);
  }
}

// This could be refactored to sendShowWelcomeScreenRequest(boolean) to allow showing/hiding in the future
export function sendCloseWelcomeScreenRequest(): ng.IPromise<IResult> {
  const serverService = ServiceLocator.get<ServerService>('ServerService');
  return serverService.sendRequest(new SetShowWelcomeScreenRequest({ showWelcomeScreen: false }));
}

export function logHomeFailure() {
  // TODO: Will be implemented when we figure out how we want to do monitoring.
}

export function* rootHomeSaga(): SagaIterator {
  yield takeEvery(HomeCloseWelcomeScreen, homeCloseWelcomeScreen);
}
